import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import UserAuth from "./UserAuth";
import { haveValue } from "../../helper/common";
import { useCookies } from "react-cookie";
import LandLordContext from "../../context/landlord/LandLordContext";

const CustomLinkAuthCheck = () => {
  const navigate = useNavigate();
  const [shouldRenderAuth, setShouldRenderAuth] = useState(false);

  const { getWorkspaceDetailsFromSlug } = useContext(LandLordContext);
  const [searchParams] = useSearchParams();
  const workspaceUuid = searchParams.get("wid");
  const { workspace_slug } = useParams();
  const [, setCookie] = useCookies(["requestProfileLink"]);

  useEffect(() => {
    let token = localStorage.getItem("token");
    let saveduserid = localStorage.getItem("saveduserid");
    let usertype = localStorage.getItem("usertype");

    if (haveValue(token) && haveValue(saveduserid)) {
      if (usertype === "tenant") {
        if (haveValue(workspace_slug) || haveValue(workspaceUuid)) {
          getWorkspaceDetailsFromSlug(workspace_slug, workspaceUuid)
            .then((res) => {
              const data = res.data;
              if (
                data.status === "Success" &&
                haveValue(data?.data?.landlord_id)
              ) {
                setCookie(
                  "requestProfileLink",
                  `${data?.data?.landlord_id}_${data?.data?.uuid}`,
                  {
                    path: "/",
                    maxAge: 604800,
                  }
                );
              }
              navigate("/home");
            })
            .catch(() => {
              navigate("/home");
            });
        } else {
          navigate("/home");
        }
      } else if (usertype === "landlord") {
        setShouldRenderAuth(true);
      } else {
        navigate("/home");
      }
    } else {
      setShouldRenderAuth(true);
    }
  }, [navigate]);

  if (shouldRenderAuth) {
    return <UserAuth />;
  }

  return null;
};

export default CustomLinkAuthCheck;
